/**
 * @generated SignedSource<<c6769ac58359236a88f89ac2b7c77acd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTable_row$data = {
  readonly cells: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_cell">;
  }>;
  readonly " $fragmentType": "WidgetTable_row";
};
export type WidgetTable_row$key = {
  readonly " $data"?: WidgetTable_row$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_row">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTable_row",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetTableCell",
      "kind": "LinkedField",
      "name": "cells",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTable_cell"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTableRow",
  "abstractKey": null
};

(node as any).hash = "6913b7dac60365a64424469354c8436c";

export default node;
